
import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class PlaneEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITPLANE;
}